<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mb-4">
              <b-col cols="12" class="mb-4">
                <h2 slot="header" class="mb-0">สร้างราคางาน</h2>
              </b-col>
            </b-row>
            <b-card-body>
              <ValidationObserver ref="observer">
                <b-form @submit="onSubmit">
                  <b-row class="mb-4">
                    <b-col cols="12" class="mb-4">
                      <h3 slot="header" class="mb-0">ข้อมูลราคางาน</h3>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="ชื่อราคางาน">
                          <b-form-input
                            v-model="form.name_rate"
                            :state="!errors.length ? null : false"
                          />
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col lg="6" cols="12">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-group label="ประเภทรถ">
                          <b-form-select
                            v-model="form.vehicle_type_id"
                            :state="!errors.length ? null : false"
                          >
                            <b-form-select-option
                              v-for="(type, i) in vehicleType"
                              :key="type.id"
                              :value="type.id"
                              >{{ type.name }}</b-form-select-option
                            >
                          </b-form-select>
                          <b-form-invalid-feedback>{{
                            errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6" cols="12">
                      <b-form-group label="รายชื่อลูกค้า">
                        <multiselect
                          v-model="form.customers"
                          placeholder="ค้นหารายชื่อ"
                          label="shop_name"
                          track-by="id"
                          :options="customer_list"
                          :multiple="true"
                        ></multiselect>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="mb-4">
                    <b-col cols="12" class="mb-4">
                      <h3 slot="header" class="mb-0">การตั้งค่าราคางาน</h3>
                    </b-col>
                  </b-row>
                  <b-row class="mb-4">
                    <b-col>
                      <b-table-simple
                        hover
                        bordered
                        responsive
                        class="text-center"
                        id="tb-rate"
                      >
                        <b-thead>
                          <b-tr variant="info">
                            <b-th colspan="1">ระยะทาง</b-th>
                            <b-th colspan="100">ราคาน้ำมัน</b-th>
                          </b-tr>
                          <b-tr variant="success">
                            <b-th colspan="1">(ขาไป-ขากลับ)</b-th>
                            <b-th>(กิโลเมตร/ลิตร) ฿</b-th>
                            <b-th
                              v-for="(price, i) in perliters_prices"
                              :key="i"
                              style="width: 150px !important;"
                            >
                              <b-row>
                                <b-col>
                                  <ValidationProvider
                                    :rules="{
                                      required: true,
                                      min_value: 1,
                                      regex: /^[0-9]*[.,]?[0-9]+$/,
                                    }"
                                    v-slot="{ errors, failedRules }"
                                  >
                                    <b-input-group size="sm">
                                      <b-form-input
                                        step="0.01"
                                        type="number"
                                        size="sm"
                                        v-model="perliters_prices[i]"
                                        @input="updatePricePerlitter(i)"
                                        :state="!errors.length ? null : false"
                                      />
                                      <b-input-group-append>
                                        <b-button
                                          variant="danger"
                                          size="sm"
                                          @click="removePerlittersPrice(i)"
                                          :disabled="
                                            perliters_prices.length < 2
                                          "
                                        >
                                          <b-icon icon="trash-fill"></b-icon>
                                        </b-button>
                                      </b-input-group-append>
                                      <b-form-invalid-feedback>
                                        <span v-if="failedRules.regex"
                                          >กรอกเฉพาะตัวเลขเท่านั้น</span
                                        >
                                        <span v-else>
                                          {{ errors[0] }}
                                        </span>
                                      </b-form-invalid-feedback>
                                    </b-input-group>
                                  </ValidationProvider>
                                </b-col>
                              </b-row>
                            </b-th>
                            <b-th>
                              <b-button
                                @click="addPerlitersPrice()"
                                size="sm"
                                pill
                                variant="outline-primary"
                              >
                                เพิ่มราคาน้ำมัน
                              </b-button>
                            </b-th>
                          </b-tr>
                        </b-thead>
                        <!-- <b-tbody>
                          <b-tr v-for="(rate, i) in form.rates" :key="i">
                            <b-th>
                              <b-row>
                                <b-col>
                                  <b-form-input
                                    size="sm"
                                    v-model="rate.start"
                                  />
                                </b-col>
                                -
                                <b-col>
                                  <b-form-input size="sm" v-model="rate.end" />
                                </b-col>
                              </b-row>
                            </b-th>
                            <b-th>ราคาขาย</b-th>
                            <b-th v-for="(price, i) in rate.prices" :key="i"
                              ><b-form-input
                                type="number"
                                size="sm"
                                v-model="price.sale_price"
                              />
                            </b-th>
                            <b-th>
                              <b-button
                                variant="outline-danger"
                                size="sm"
                                @click="removeDistance(i)"
                                :disabled="form.rates.length < 2"
                              >
                                <b-icon icon="trash-fill"></b-icon>
                              </b-button>
                            </b-th>
                          </b-tr>
                          <b-tr>
                            <b-th colspan="100">
                              <b-button
                                @click="addDistance()"
                                size="sm"
                                pill
                                variant="outline-primary"
                              >
                                เพิ่มระยะทาง
                              </b-button>
                            </b-th>
                          </b-tr>
                        </b-tbody> -->
                        <b-tbody>
                          <b-tr v-for="(rate, i) in form.rates" :key="i">
                            <b-th>
                              <b-row>
                                <b-col>
                                  <ValidationProvider
                                    :rules="{
                                      required: true,
                                      firstRateStartZero: {
                                        rates: form.rates,
                                        isFirst: i === 0,
                                      },
                                      subsequentRateStartGreaterThanPreviousEnd: {
                                        rates: form.rates,
                                        index: i,
                                      },
                                    }"
                                    v-slot="{ errors }"
                                  >
                                    <b-form-input
                                      type="number"
                                      size="sm"
                                      v-model="rate.start"
                                      :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                      {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                  </ValidationProvider>
                                </b-col>
                                -
                                <b-col>
                                  <ValidationProvider
                                    :rules="{
                                      required: true,
                                      rateEndGreaterThanStart: {
                                        start: rate.start,
                                      },
                                    }"
                                    v-slot="{ errors }"
                                  >
                                    <b-form-input
                                      size="sm"
                                      v-model="rate.end"
                                      :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                      {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                  </ValidationProvider>
                                </b-col>
                              </b-row>
                            </b-th>
                            <b-th>ราคาขาย</b-th>
                            <b-th
                              v-for="(price, j) in rate.prices"
                              :key="`price-${i}-${j}`"
                            >
                              <ValidationProvider
                                :rules="{
                                  required: true,
                                  min_value: 1,
                                  regex: /^[0-9]*[.,]?[0-9]+$/,
                                }"
                                v-slot="{ errors, failedRules }"
                              >
                                <b-form-input
                                  step="0.01"
                                  type="number"
                                  size="sm"
                                  v-model="price.sale_price"
                                  :state="!errors.length ? null : false"
                                />
                                <b-form-invalid-feedback>
                                  <span v-if="failedRules.regex"
                                    >กรอกเฉพาะตัวเลขเท่านั้น</span
                                  >
                                  <span v-else>
                                    {{ errors[0] }}
                                  </span>
                                </b-form-invalid-feedback>
                              </ValidationProvider>
                            </b-th>
                            <b-th>
                              <b-button
                                variant="outline-danger"
                                size="sm"
                                @click="removeDistance(i)"
                                :disabled="form.rates.length < 2"
                              >
                                <b-icon icon="trash-fill"></b-icon>
                              </b-button>
                            </b-th>
                          </b-tr>
                          <b-tr>
                            <b-th colspan="100">
                              <b-button
                                @click="addDistance()"
                                size="sm"
                                pill
                                variant="outline-primary"
                              >
                                เพิ่มระยะทาง
                              </b-button>
                            </b-th>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </b-col>
                  </b-row>
                  <hr class="my-3" />
                  <div class="d-flex justify-content-between">
                    <base-button
                      type="secondary"
                      class=""
                      @click="confirmAndGoBack"
                    >
                      ย้อนกลับ
                    </base-button>
                    <b-button
                      type="submit"
                      variant="primary"
                      :disabled="isLoading"
                      >บันทึก</b-button
                    >
                  </div>
                </b-form>
              </ValidationObserver>
            </b-card-body>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import vehicleTypeServices from "@/api/vehicle-type.service.js";
import rateServices from "@/api/rate.service.js";
import customerServices from "@/api/customer.service.js";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      customer_list: [],
      vehicleType: [],
      isLoading: false,
      perliters_prices: [29],
      form: {
        name_rate: "",
        vehicle_type_id: null,
        customers: [],
        rates: [
          {
            start: 0,
            end: 20,
            prices: [
              {
                price_perliter: 29,
                sale_price: 0,
              },
            ],
          },
        ],
      },
    };
  },
  created() {
    this.getVehicleType();
    this.getCustomerList();
  },
  methods: {
    async getCustomerList() {
      try {
        const response = await customerServices.getCustomerList();
        this.customer_list = response.data.data;
      } catch (error) {}
    },
    async getVehicleType() {
      try {
        const response = await vehicleTypeServices.getVehicleType();
        this.vehicleType = response.data.data;
        if (this.vehicleType[0]) {
          this.form.vehicle_type_id = this.vehicleType[0].id;
        }
      } catch (error) {}
    },
    async onSubmit(event) {
      event.preventDefault();
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      }

      if (this.form.customers.length > 0) {
        this.form.customers = this.form.customers.map((cs) => cs.id);
      }

      try {
        this.isLoading = true;
        const response = await rateServices.createRate(this.form);

        this.$refs.observer.reset();
        this.form = {
          name_rate: "",
          vehicle_type_id: null,
          rates: [
            {
              start: 0,
              end: 20,
              prices: [
                {
                  price_perliter: 29,
                  sale_price: 0,
                },
              ],
            },
          ],
        };

        alert("สร้างราคางานเสร็จสิ้น");
        this.$router.push({
          name: "manageRate",
        });
      } catch (error) {
        // จัดการกับข้อผิดพลาดในกรณีที่เกิดข้อผิดพลาดในการโพสต์ข้อมูล
        console.error("Error creating rate", error);
      } finally {
        this.isLoading = false;
      }
    },
    addPerlitersPrice() {
      this.perliters_prices.push(0);
      this.form.rates.map((rate) => {
        rate.prices.push({
          price_perliter: 0,
          sale_price: 0,
        });
      });
    },
    removePerlittersPrice(i) {
      if (!window.confirm("ต้องการลบราคาน้ำมันหรือไม่ ?")) {
        return;
      }
      this.perliters_prices.splice(i, 1);
      this.form.rates.map((rate) => {
        rate.prices.splice(i, 1);
      });
    },
    updatePricePerlitter(i) {
      this.form.rates.map((rate) => {
        rate.prices[i].price_perliter = this.perliters_prices[i];
      });
    },
    addDistance() {
      const lastRateIndex = this.form.rates.length - 1;
      const start = +this.form.rates[lastRateIndex].end + 1;
      const end = start + 1;
      const prices = [];
      this.perliters_prices.map((price) => {
        prices.push({
          price_perliter: price,
          sale_price: 0,
        });
      });
      this.form.rates.push({
        start,
        end,
        prices,
      });
    },
    removeDistance(i) {
      if (!window.confirm("ต้องการลบระยะทางหรือไม่ ?")) {
        return;
      }
      this.form.rates.splice(i, 1);
    },
    confirmAndGoBack() {
      // ใช้ window.confirm เพื่อแสดงกล่องยืนยัน
      if (window.confirm("คุณต้องการที่จะย้อนกลับหรือไม่?")) {
        // ถ้าผู้ใช้ยืนยัน ให้ใช้ router.go(-1) เพื่อย้อนกลับ
        this.$router.go(-1);
      } else {
        // ถ้าผู้ใช้ยกเลิก ไม่ต้องทำอะไร
      }
    },
  },
};
</script>